export const LOCALE_SETTING_TIME_FRAME_LABEL = 'Time Frame';
export const LOCALE_SETTING_WEIGHTING_MODE_LABEL = 'Weighting Mode';
export const LOCALE_SETTING_GRANULARITY_LABEL = 'Granularity';
export const LOCALE_SETTING_TIME_ZONE_LABEL = 'Time Zone';
export const LOCALE_SETTING_SAMPLE_FACTOR_LABEL = 'Sample factor';
